module.exports = __webpack_public_path__ + "img/square-up-right.2f1a4b24.svg";